
export const Funciones = () => {
    return {
        toCurrency(val, dec){
            const valor = parseFloat(val);
            return '$' + (valor.toFixed(dec)).toString();
        },
        toNumber(val, dec){
            const valor = parseFloat(val);
            return (valor.toFixed(dec)).toString();
        },
        toDate(dateString, formatChar='YMD',sepChar='/'){
            try{
                let staDate = Date.parse(dateString)
                let date = staDate.getDate();
                let month = staDate.getMonth() + 1;
                let year = staDate.getFullYear();
                console.log(dateString);
                console.log(staDate);
                let newdate = year.toString() + sepChar + (month<10?'0'+month.toString():month.toString())+sepChar+(date<10?'0'+date.toString():date.toString());

                switch (formatChar) {
                    case 'YMD':
                        newdate = year.toString() + sepChar + (month<10?'0'+month.toString():month.toString())+sepChar+(date<10?'0'+date.toString():date.toString());
                        break;

                    case 'DMY':
                        newdate = (date<10?'0'+date.toString():date.toString()) + sepChar + (month<10?'0'+month.toString():month.toString()) + sepChar + year.toString();
                        break;
                
                    default:
                        newdate = year.toString() + sepChar + (month<10?'0'+month.toString():month.toString())+sepChar+(date<10?'0'+date.toString():date.toString());
                        break;
                }

                return newdate;

            }catch(ex){
                //nothing
                console.log(ex);
                return this.getDate(sepChar);
            }

        },
        getDate(sepChar='/'){
            let staDate = new Date()
            let date = staDate.getDate();
            let month = staDate.getMonth() + 1;
            let year = staDate.getFullYear();
            let newdate = year.toString() + sepChar + (month<10?'0'+month.toString():month.toString())+sepChar+(date<10?'0'+date.toString():date.toString());

            return newdate
        },
        getDMY(ndate, sepChar) {
            let date = ndate.getDate();
            let month = ndate.getMonth() + 1;
            let year = ndate.getFullYear();
            let newdate = (ndate<10?'0'+date.toString():date.toString()) + sepChar + (month<10?'0'+month.toString():month.toString()) + sepChar + year.toString();

            return newdate
        }
    }
}